module.exports = __webpack_public_path__ + "img/art-7.03622ba7.jpg";